import { Component } from "solid-js";
import wallpaper from "../../assets/wallpaper.webp";
import { Locale, createLocalI18n } from "../../i18n.js";

const i18nDefault = {
  title: "The Next Generation Discord Bots & Tools",
  description:
    "Improve your community engagement with customisable Bots & Tools, throw game integration like Garry's Mod, S&Box, FiveM, but also discord utilities like ticket system, moderation, and more.",
  cta: "Go to Dashboard",
  soon: "Soon",
};

const i18nLocalDicts: Record<Locale, typeof i18nDefault> = {
  [Locale.US]: i18nDefault,
  [Locale.FR]: {
    title: "La prochaine génération de Bots & Outils Discord",
    description:
      "Améliorez l'engagement de votre communauté avec des Bots & Outils personnalisables, intégrez des jeux comme Garry's Mod, S&Box, FiveM, mais aussi des utilitaires Discord comme un système de ticket, de modération, et plus encore.",
    cta: "Aller au Tableau de bord",
    soon: "Bientôt",
  },
};

const { localChained } = createLocalI18n(i18nDefault, i18nLocalDicts);

const Hero: Component = () => {
  return (
    <div class="hero relative min-h-[700px] flex overflow-hidden">
      <div
        class="absolute inset-0 bg-cover bg-center min-w-[1920px] w-full max-w-[2560px] h-[700px] object-cover object-bottom blur-[7px] opacity-35"
        style={`background-image: url(${wallpaper}); background-position: center; left: 50%; transform: translateX(-50%);`}
      />

      <div class="flex flex-col relative z-10 gap-8 max-w-screen-xl w-full mx-auto p-8">
        <h1
          class="text-5xl font-bold text-base-content max-w-2xl"
          style="background: linear-gradient(to bottom, #3B90C2FF, #25AA8DFF); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"
        >
          {localChained.title()}
        </h1>
        <div class="text-lg text-base-content/80 max-w-2xl">
          {localChained.description()}
        </div>
        <div
          // href="/dashboard/guilds"
          class="btn btn-outline btn-primary text-nowrap max-w-max"
        >
          {localChained.cta()} ({localChained.soon()})
        </div>
      </div>
    </div>
  );
};

export default Hero;
